import axios from 'axios'
import i18n from "../i18n";
import { mapState } from 'vuex';

export default {
    data() {
        return {
            items: [],
            modules: {
                CHARGES: "trip",
                REGISTER: "/auth/register",
                VEHICLES: "vehicle",
                REQUESTS: "requests",
                DIRECTORIES: "directories",
                USER: "user/update",
            },
            itemsPerPage: {
                label: "Results",
                values: [10, 20, 50, 100],
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            search: '',
            loading: false
        }
    },
    computed: {
        ...mapState({
            token: state => state.token,
        }),
        isEditing() {
            return Boolean(this.$route.params.id);
        }
    },
    methods: {
        getRowCount(items) {
            return items.length;
        },
        getRecords(code) {
            const token = localStorage.getItem('token', null);

            axios.get(`${this.modules[code]}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                })
                .then(response => {
                    this.items = response.data.data;
                }).catch(error => {
                    if (error.response.status === 401) {
                        this.$router.push({ path: '/login' });
                    } else {
                        this.$toast.error(error);
                    }
                });
        },
        updatePerPage(val) {
            this.perPage = val;
        },
        createRecord(code, data, isEditing) {
            const token = localStorage.getItem('token', null);

            if (isEditing) {
                axios.post(`${this.modules[code]}`, data, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        }
                    })
                    .then(() => {
                        //this.$router.push(`/${this.modules[code]}`);
                        this.$toast.success(i18n.t('success_modify'));
                    }).catch(error => {
                        if (error.response.status === 401) {
                            this.$router.push({ path: '/login' });
                        } else {
                            this.$toast.error(error);
                        }
                    });
            } else {
                if (code == "REGISTER") {
                    axios.post(`${this.modules[code]}`, data)
                        .then(response => {
                            if (code == "REGISTER") {
                                if (response.data.success) {
                                    this.$router.push(`/login`);
                                } else {
                                    if (response.data.errors.name) { 
                                        console.log(response.data.errors.name);
                                        this.$toast.error(response.data.errors.name[0]);
                                    }
                                    if (response.data.errors.password) { 
                                        console.log(response.data.errors.password[0]);
                                        this.$toast.error(response.data.errors.password[0]);
                                    }
                                    if (response.data.errors.phone) { 
                                        console.log(response.data.errors.phone);
                                        this.$toast.error(response.data.errors.phone[0]);
                                    }
                                    if (response.data.errors.rol_id) { 
                                        console.log(response.data.errors.rol_id);
                                        this.$toast.error(response.data.errors.rol_id[0]);
                                    }
                                    if (response.data.errors.email) { 
                                        console.log(response.data.errors.email);
                                        this.$toast.error(response.data.errors.email[0]);
                                    }
                                    if (response.data.errors.sizes) { 
                                        console.log(response.data.errors.sizes);
                                        this.$toast.error(response.data.errors.sizes[0]);
                                    }
                                    if (response.data.errors.state_id) { 
                                        console.log(response.data.errors.state_id);
                                        this.$toast.error(response.data.errors.state_id[0]);
                                    }
                                }
                            }
                        }).catch(error => {
                            let message = "";
                            if (error.response.status === 401) {
                                this.$router.push({ path: '/login' });
                            } else {
                                if (error.response.data.errors) {
                                    for (let key in error.response.data.errors) {
                                        if (error.response.data.errors.hasOwnProperty(key)) {
                                            message += error.response.data.errors[key][0] + '  ';
                                        }
                                    }
                                } else {
                                    message = error.response.data.message;
                                }
                                this.$toast.error(message);
                            }
                        });
                } else {
                    axios.post(`${this.modules[code]}`, data, {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                            }
                        })
                        .then(response => {
                            if (code == "CHARGES") {
                                this.$router.push(`/charges`);
                            }
                            if (code == "VEHICLES") {
                                this.$router.push(`/vehicles`);
                            }
                            if (code == "REGISTER") {
                                if (response.data.success) {
                                    this.$router.push(`/login`);
                                } else {
                                    if (response.data.errors.name) { 
                                        console.log(response.data.errors.name);
                                        this.$toast.error(response.data.errors.name[0]);
                                    }
                                    if (response.data.errors.password) { 
                                        console.log(response.data.errors.password[0]);
                                        this.$toast.error(response.data.errors.password[0]);
                                    }
                                    if (response.data.errors.phone) { 
                                        console.log(response.data.errors.phone);
                                        this.$toast.error(response.data.errors.phone[0]);
                                    }
                                    if (response.data.errors.rol_id) { 
                                        console.log(response.data.errors.rol_id);
                                        this.$toast.error(response.data.errors.rol_id[0]);
                                    }
                                    if (response.data.errors.email) { 
                                        console.log(response.data.errors.email);
                                        this.$toast.error(response.data.errors.email[0]);
                                    }
                                }
                            }
                            if (code == "REQUESTS") {
                                this.$toast.success(i18n.t('success_create'));
                                this.$router.push(`/requests`);
                            } else {
                                this.$toast.success(response.data.message);
                            }
                        }).catch(error => {
                            let message = "";
                            if (error.response.status === 401) {
                                this.$router.push({ path: '/login' });
                            } else {
                                if (error.response.data.errors) {
                                    for (let key in error.response.data.errors) {
                                        if (error.response.data.errors.hasOwnProperty(key)) {
                                            message += error.response.data.errors[key][0] + '  ';
                                        }
                                    }
                                } else {
                                    message = error.response.data.message;
                                }
                                this.$toast.error(message);
                            }
                        });
                }
            }
        },
        createWithFilesRecord(code, data) {
            const token = localStorage.getItem('token', null);

            if (this.isEditing) {
                axios.post(`${this.modules[code]}/${this.$route.params.id}`, 
                    data,            
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(() => {
                        this.$toast.success(i18n.t('success_modify'));
                    }).catch(error => {
                        if (error.response.status === 401) {
                            this.$router.push({ path: '/login' });
                        } else {
                            this.$toast.error(error);
                        }
                    });
            } else {
                axios.post(`${this.modules[code]}`, 
                    data,            
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                        this.items = response.data;
                        this.$router.push(`/${this.modules[code]}`);
                        this.$toast.success(i18n.t('success_create'));
                    }).catch(error => {
                        let message = "";
                        if (error.response.status === 401) {
                            this.$router.push({ path: '/login' });
                        } else {
                            if (error.response.data.errors) {
                                for (let key in error.response.data.errors) {
                                    if (error.response.data.errors.hasOwnProperty(key)) {
                                        message += error.response.data.errors[key][0] + '  ';
                                    }
                                }
                            } else {
                                message = error.response.data.message;
                            }
                            this.$toast.error(message);
                        }
                    });
            }
        },
        modifyRecord(code, id) {
            this.$router.push(`/${this.modules[code]}/${id}/edit`);
        },
        deleteRecord(code, id) {
            const token = localStorage.getItem('token', null);
            this.$confirm(i18n.t('are_sure')).then(() => {
                axios.delete(`api/${this.modules[code]}/${id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                        }
                    })
                    .then(() => {
                        this.getRecords(code);
                        this.$toast.success(i18n.t('success_delete'));
                    }).catch(error => {
                        if (error.response.status === 401) {
                            this.$router.push({ path: '/login' });
                        } else {
                            this.$toast.error(error);
                        }
                    });
            }).catch(() => {
            });
        }
    }
};
